var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page wrap"},[_c('sysmenu'),_c('div',{class:['rightcontent', _vm.$store.state.leftmenu ? '' : 'expand']},[_c('GlobalHeader',{attrs:{"enterInfo":_vm.enterInfo}}),_c('div',{staticClass:"rightpage"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }